import { SvgIcon, type SvgIconProps } from './svgIcon'

export function GraphIcon({ width = 24, height = 24, ...props }: SvgIconProps) {
  return (
    <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
      <path
        d="M5.5 22V12M12 22V2M18.5 22V7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </SvgIcon>
  )
}
